import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

function SelectInput({
  options = [],
  value,
  name,
  onChange,
  labelKey,
  valueKey,
  isMulti = false,
  defaultValue,
  isDisabled = false,
  closeMenuOnSelect = true,
  isLoading = false,
  isClearable = true,
  placeholder = "",
  label,
  required,
  errorMessage = "", // Change this to a string for better handling
  handleBlur, // Receive handleBlur from parent
}) {
  // Prepend the "Select" option to the options array
  // const selectOptions = [
  //   { [labelKey]: placeholder, [valueKey]: "" }, // First option with empty value
  //   ...options,
  // ];
  //const selectOptions = options.filter(option => option[valueKey] !== "");

  // const selectOptions = [
  //   ...options.filter((option) => option[valueKey] === value), // Selected option
  //   ...options.filter((option) => option[valueKey] !== value), // Other options
  // ];

  const safeOptions = Array.isArray(options) ? options : [];

const selectOptions = [
  ...safeOptions.filter((option) => option[valueKey] === value),
  ...safeOptions.filter((option) => option[valueKey] !== value),
];

  // Get the selected value
  const selectedValue = selectOptions?.find(
    (option) => option[valueKey] === value
  ) || null;

  // Custom styles for error handling and focus
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: "40px",
      minHeight: "40px",
      borderColor: errorMessage ? "#c8605e" : base.borderColor,
      "&:hover": {
        borderColor: errorMessage ? "#c8605e" : base.borderColor,
      },
      boxShadow: state.isFocused
        ? errorMessage
          ? "0 0 5px 1px #c8605e" // Red shadow when focused if there's an error
          : base.boxShadow
        : null,
    }),
    // Optionally style the dropdown menu
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  // Ensure onBlur event sends the correct name and value
  const handleSelectBlur = () => {
    const valueForBlur = selectedValue ? selectedValue[valueKey] : "";
    // Pass a simulated event with correct name and value
    if (handleBlur) {
      handleBlur({
        target: {
          name, // Ensure name is passed correctly here
          value: valueForBlur, // Pass the selected value
        },
      });
    }
  };

  return (
    <div>
      <label
        className="col-md-3 w-100 form-label w-100 inmate-label"
        // style={{ color: "#2c2f32", fontWeight: "400" }}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <Select
        className={`fs-5 mb-1 ${errorMessage ? "border-danger" : ""}`} // Add error class for Select if needed
        name={name} // Ensure name prop is passed here
        styles={customStyles} // Apply the custom styles
        options={selectOptions.map((option) => ({
          label: option[labelKey],
          value: option[valueKey],
        }))}
        value={
          selectedValue
            ? { label: selectedValue[labelKey], value: selectedValue[valueKey] }
            : null
        }
        onChange={onChange}
        onBlur={handleSelectBlur} // Attach the synthetic blur event
        isMulti={isMulti}
        defaultValue={defaultValue}
        closeMenuOnSelect={closeMenuOnSelect}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        placeholder={placeholder}
        menuPlacement="auto"
      />
      {errorMessage && ( // Display error message if present
        <div className="text-danger fw-700 fs-6 mt-1">
          {errorMessage} {/* Display error message */}
        </div>
      )}
    </div>
  );
}

SelectInput.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string.isRequired, // Ensure name is required
  onChange: PropTypes.func.isRequired,
  labelKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
 // required: PropTypes.bool,
  errorMessage: PropTypes.string, // Ensure errorMessage is a string
  handleBlur: PropTypes.func.isRequired, // Ensure handleBlur is required
};

export default SelectInput;
